import axiosInstance from "./axiosInstance";

export async function BoschAxios(url, method, body, token, extraHeaders = {}) {
  let config = {
    headers: {
      Authorization: "Bearer " + token,
      ...extraHeaders,
    },
  };

  let configMultipart = {
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "multipart/form-data",
      ...extraHeaders,
    },
  };

  if (method == "MULTIPART") {
    return axiosInstance.post(url, body, configMultipart);
  }

  if (method == "GET") {
    return (await axiosInstance.get(url, config)).data;
  }

  if (method == "POST") {
    return axiosInstance.post(url, body, config);
  }
  if (method == "PUT") {
    return axiosInstance.put(url, body, config);
  }
  if (method == "PATCH") {
    return axiosInstance.patch(url, body, config);
  }
  if (method == "DELETE") {
    return axiosInstance.delete(url, config);
  }
}
